// extracted by mini-css-extract-plugin
export default {"config-list":"ZU2xva"};